import React, { useEffect } from "react";
import "./LineTime.css";
import '../styles.css'

export default function LineTime({ events, title }) {
  useEffect(() => {
    const items = document.querySelectorAll(".timeline-item");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("fade-in");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    items.forEach((item) => observer.observe(item));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="container py-5">
      <h2 className="text-center mb-5">{title}</h2>

      {/* Timeline */}
      <div className="timeline">
        {events.map((event, index) => (
          <div
            key={index}
            className={`timeline-item ${index % 2 === 0 ? "left" : "right"}`}
          >
            <div className="timeline-content shadow-sm p-3 rounded">
              <h5>{event.year}</h5>
              <h4 className="fw-bold">{event.title}</h4>
              <p>{event.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
